import React, { useState } from 'react';

import Carousel from 'components/base/Carousel';

import Slide from './components/Slide';

import { Wrapper, Button } from './styles';

const slides = [
  {
    key: 'welcome',
    title: 'Update your User Profile',
    text: "Let's get to know each other better. It would be great if you could answer a few questions about yourself.",
  },
  {
    key: 'location',
    title: 'Confirm your Office Location',
    text: 'If incorrect please select the correct location.',
  },
  {
    key: 'division',
    title: 'Which division do you work for?',
  },
  {
    key: 'role',
    title: 'Which best describes your role?',
  },
  {
    key: 'thank',
    title: 'Thank you!',
    text: 'You can update your profile by selecting the account icon from the navigation at any time.',
  },
];

interface IOnboardingFormProps {
  onCloseClick: Function;
}

const OnboardingForm: React.FC<IOnboardingFormProps> = (props) => {
  const { onCloseClick } = props;
  const [customSelecetedItemIndex, setCustomSelecetedItemIndex] = useState(0);
  const [buttonText, setButtonText] = useState('Get Started');

  const onClick = (): any => {
    if (buttonText === 'Submit') {
      onCloseClick();
      return;
    }
    const newValue = customSelecetedItemIndex + 1;
    setCustomSelecetedItemIndex(newValue);
    if (newValue > 0 && newValue < 4) {
      setButtonText('Next');
    } else {
      setButtonText('Submit');
    }
  };

  return (
    <Wrapper>
      <Carousel
        customSelecetedItemIndex={customSelecetedItemIndex}
        emulateTouch={false}
        alignDots="left"
        minHeightSlide="235px"
        animationHandler="fade"
        withoutButtons
        overflowVisible
        disabledDots
      >
        {slides.map(({ key, title, text }: any) => (
          <Slide key={key} title={title} text={text} type={key} />
        ))}
      </Carousel>
      <Button variant="primary" onClick={onClick}>
        {buttonText}
      </Button>
    </Wrapper>
  );
};

export default OnboardingForm;
